module.exports = __webpack_public_path__ + "img/bs_silo_6.a8e62076.png";